import axios from 'axios';
import { API_BASE_URL } from '@/app/config/api';
import { useAuthStore } from '@/app/store/authStore'; // Import the auth store

console.log('🌐 Axios Instance - API_BASE_URL:', API_BASE_URL);

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to include the auth token
axiosInstance.interceptors.request.use(
    (config) => {
        // Get token from auth store or localStorage
        const authState = useAuthStore.getState();
        const token = authState.token || localStorage.getItem('authToken');
        
        console.log('🔑 Request interceptor - Token:', token ? 'Found' : 'Not found');
        console.log('🎯 Request to:', config.url);
        console.log('📡 Full URL:', (config.baseURL || '') + (config.url || ''));
        console.log('📦 Request params:', config.params);
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('❌ Request interceptor error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for global error handling
axiosInstance.interceptors.response.use(
    (response) => {
        console.log('✅ Response interceptor - Success:', response.config.url);
        return response;
    },
    (error) => {
        console.error('❌ Response interceptor - Error:', error);
        console.error('🔍 Error response:', {
            status: error.response?.status,
            data: error.response?.data,
            url: error.config?.url,
            baseURL: error.config?.baseURL
        });
        
        if (error.response) {
            // Handle based on status code
            if (error.response.status === 401) {
                // Unauthorized - Not logged in or invalid token
                console.error("Unauthorized access - logging out via authStore.");
                // Use the logout action from the store
                useAuthStore.getState().logoutAction(); 
                // No need for localStorage.removeItem or window.location here
            } 
            // Don't automatically redirect on 403 (Forbidden)
            // Let the component handle it with a proper error message
            else if (error.response.status === 403) {
                console.error("Forbidden - User doesn't have permission");
                // Don't redirect - let component handle this
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 